<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-monitor"></i> 广告列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="广告标题">
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入广告标题"
              prefix-icon="el-icon-search"
              clearable
              class="search-input"
              @keyup.enter.native="searchSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="addData" icon="el-icon-plus">新增广告</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-monitor"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总广告数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon today">
            <i class="el-icon-timer"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ todayCount }}</div>
            <div class="stat-label">今日新增</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="广告标题" min-width="200" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="ad-title">
                <i class="el-icon-monitor"></i>
                <span>{{ scope.row.ad_name }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="广告位置" width="150" align="center">
            <template slot-scope="scope">
              <el-tag size="small" type="primary" effect="plain">
                <i class="el-icon-location"></i>
                {{ scope.row.position ? scope.row.position.position_name : '-' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="所属商家" width="160" align="center">
            <template slot-scope="scope">
              <div class="shop-info">
                <i class="el-icon-shop"></i>
                <span>{{ scope.row.shop ? scope.row.shop.name : '-' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="发布日期" width="180" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="140" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="edit-btn"
                @click="handleClick(scope.row)"
              >
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button 
                type="text" 
                size="small" 
                class="delete-btn"
                @click="del(scope.row)"
              >
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-monitor"></i>
        <p>暂无广告数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "adList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: "",
      },
      
      // 统计数据
      todayCount: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      showType: ''
    }
  },
  created() {
    this.DataList()
    this.getTodayCount()
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() {
      return {
        cursor: 'pointer'
      }
    },
    
    // 获取今日新增数量
    getTodayCount() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        shop_id: sessionStorage.getItem('shop_id'),
        start_time: moment().startOf('day').format('YYYY-MM-DD'),
        end_time: moment().endOf('day').format('YYYY-MM-DD')
      }
      this.$axios.adList(param).then(res => {
        if (res.code == 200) {
          this.todayCount = (res.data && res.data.total) || 0
        }
      }).catch(error => {
        console.log(error)
      })
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    // 获取广告列表
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        shop_id: sessionStorage.getItem('shop_id')
      }
      
      if (this.searchForm.name) {
        param.ad_name = this.searchForm.name
      }
      
      this.$axios.adList(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    // 新增广告
    addData() {
      this.$router.push('/adForm')
    },
    
    // 编辑广告
    handleClick(row) {
      this.$router.push({
        path: '/adForm',
        query: {
          ad_id: row.ad_id
        }
      })
    },
    
    // 删除广告
    del(row) {
      this.$confirm(`确定要删除广告"${row.ad_name}"吗？删除后无法恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: row.ad_id,
        }
        this.$axios.adDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.pageNum = 1
            this.DataList()
            this.getTodayCount()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          console.log(error)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 面包屑样式
.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

// 卡片样式
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item {
    margin-bottom: 0;
  }
  
  .search-input {
    width: 280px;
  }
  
  .search-input .el-input__inner {
    border-radius: 20px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 20px;
    padding: 8px 20px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
  
  .el-button--success {
    background: #00b578;
    border-color: #00b578;
    border-radius: 20px;
    padding: 8px 20px;
    
    &:hover {
      background: #1acd8c;
      border-color: #1acd8c;
    }
  }
}

// 统计卡片样式
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  .stat-card {
    flex: 1;
    min-width: 180px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
    
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      
      &.total {
        background: linear-gradient(135deg, #1677ff, #4096ff);
      }
      
      &.today {
        background: linear-gradient(135deg, #00b578, #1acd8c);
      }
    }
    
    .stat-info {
      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: #1f2d3d;
        line-height: 1.2;
      }
      
      .stat-label {
        font-size: 13px;
        color: #8c8f98;
        margin-top: 4px;
      }
    }
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 20px;
  min-height: 350px;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table::before {
  display: none;
}

.el-table th {
  background: #fafbfc !important;
  font-weight: 500;
}

.el-table td {
  border-bottom: 1px solid #f0f0f0;
}

.el-table .el-table__row {
  transition: background 0.2s;
}

.el-table .el-table__row:hover {
  background: #f8f9fc;
}

.ad-title {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 16px;
    color: #1677ff;
  }
  
  span {
    font-weight: 500;
    color: #1f2d3d;
  }
}

.shop-info {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    font-size: 14px;
    color: #00b578;
  }
  
  span {
    font-size: 13px;
  }
}

.time-text {
  font-size: 12px;
  color: #8c8f98;
}

.edit-btn {
  color: #1677ff;
  margin-right: 12px;
  
  i {
    margin-right: 4px;
  }
  
  &:hover {
    color: #4096ff;
  }
}

.delete-btn {
  color: #ff4d4f;
  
  i {
    margin-right: 4px;
  }
  
  &:hover {
    color: #ff7875;
  }
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
  
  .el-button {
    margin-top: 20px;
    border-radius: 20px;
  }
}

// 分页样式
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.el-pagination .el-pager li.active {
  background: #1677ff;
  color: #fff;
}

.el-pagination .el-pagination__total {
  color: #8c8f98;
}
</style>